import { useTranslations } from 'next-intl'

import { Form } from '@/shared/ui'

export const CashReceiptPersonalField = () => {
  const t = useTranslations('receipt_information.issue_request')

  return (
    <Form.Field name="personalIssuanceNumber">
      <Form.Label bold>{t('phone_or_card_number.label')}</Form.Label>
      <Form.TextField
        type="number"
        placeholder={t('phone_or_card_number.placeholder')}
        fullWidth
      />
      <Form.Message />
    </Form.Field>
  )
}
